import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import React from 'react';
import styled from 'styled-components';
import THEME from '../../styles/colors';
import Icon from '../Icon/Icon';
import StyledButton, { ButtonFill } from './StyledButton';

const PADDING = 8;

export const StyledIconButton = styled(StyledButton)`
  padding: ${PADDING}px;
  border-radius: 100%;
  ${({ $size = 8 }) => `
    height: ${$size + PADDING}px;
    width: ${$size + PADDING}px;
  `}
  & svg, & svg * {
    color: ${THEME.other.icon};
    fill: ${THEME.other.icon};
  }
`;

interface IIconButtonProps {
  onClick: Function;
  size?: number;
  icon?: any;
}

const IconButton: React.FC<IIconButtonProps> = ({
  onClick,
  size = 20,
  icon = faTimes,
  ...rest
}) => (
  <StyledIconButton
    onClick={onClick}
    $fillMode={ButtonFill.Link}
    $size={size}
    {...rest}
  >
    <Icon icon={icon} color={THEME.other.icon} size={size} />
  </StyledIconButton>
);

export default IconButton;
